<div class="box">
  <div class="title">
    <h3>
      <b>{{ title }}</b> <span *ngIf="title !== 'Baselines' && type !== 'ticket'" style="color: red"> *</span>
    </h3>
  </div>
  <!-- Alert Content -->
  <ng-container *ngIf="type === 'event' && arrayList.length > 0">
    <div class="summary">
      <div class="flex-col">
        <mat-grid-list cols="2" rowHeight="2:1">
          <div style="width: 90%" *ngFor="let item of groupedArrayListBySeverity | keyvalue">
            <mat-grid-tile *ngIf="item.key === 'critical' || item.key === 'danger'">
              <!-- No. of Alert Events by Severity -->
              <mat-card mat-elevation-z5 class="severity">
                <mat-card-content [ngSwitch]="item.key">
                  <h1 *ngSwitchCase="'critical'" class="critical">
                    {{ item.value.length }}<br />
                    Critical <mat-icon class="top critical" svgIcon="error"></mat-icon>
                  </h1>
                  <h1 *ngSwitchCase="'danger'" class="danger">
                    {{ item.value.length }}<br />
                    Danger <mat-icon class="top danger" svgIcon="warning"></mat-icon>
                  </h1>
                </mat-card-content>
              </mat-card>
            </mat-grid-tile>
          </div>
        </mat-grid-list>

        <!-- Geolocations list -->
        <div class="flex-row" *ngIf="event_occurence_by_countries.length > 0">
          <div class="row-item">
            <mat-card mat-elevation-z5>
              <mat-card-content style="justify-content: flex-start !important">
                <span
                  ><b>From {{ event_occurence_by_countries.length }} Geolocation(s):</b></span
                >
                <mat-list *ngFor="let geo of event_occurence_by_countries">
                  <mat-list-item role="listitem">
                    {{ getEntries(geo)[0] }} x {{ getEntries(geo)[1] }}
                    {{ showUserOrCountByGeo(geo.users) }}
                  </mat-list-item>
                </mat-list>
              </mat-card-content>
            </mat-card>
          </div>
          <!-- <div class="row-item google-map-container">
            <lib-geolocation-map></lib-geolocation-map>
          </div> -->
        </div>
      </div>
    </div>
  </ng-container>

  <!-- Baseline Content -->
  <ng-container *ngIf="type === 'baseline deviation'">
    <mat-list>
      <div class="flex-col">
        <h4 style="margin-block: 0">Current Posture Summary (All time)</h4>
        <div class="flex-row">
          <div class="row-item">
            <div class="row-item">
              <span style="line-height: 2"><b>Tenant</b></span>
            </div>
            <div class="row-item">
              <span>Passing: </span>
              <span style="float: right; color: green">
                {{ !!tenant_posture_counts?.not_deviated ? tenant_posture_counts?.not_deviated : '-' }}</span
              >
            </div>
            <div class="row-item">
              <span>Deviating: </span>
              <span style="float: right; color: red">{{
                !!tenant_posture_counts?.has_deviated ? tenant_posture_counts?.has_deviated : '-'
              }}</span>
            </div>
          </div>
          <div class="row-item">
            <div class="row-item">
              <span style="line-height: 2"><b>Group</b></span>
            </div>
            <div class="row-item">
              <span>Passing: </span>
              <span style="float: right; color: green">
                {{ !!group_posture_counts?.not_deviated ? group_posture_counts?.not_deviated : '-' }}</span
              >
            </div>
            <div class="row-item">
              <span>Deviating: </span>
              <span style="float: right; color: red">{{
                !!group_posture_counts?.has_deviated ? group_posture_counts?.has_deviated : '-'
              }}</span>
            </div>
          </div>
        </div>
      </div>
    </mat-list>
    <div class="summary">
      <h4 style="margin-block-end: 0.5rem">Posture Summary (In this period) <span style="color: red"> *</span></h4>
      <div
        *ngIf="
          tenant_baselines_posture_controls_in_this_period !== null &&
            group_baselines_posture_controls_in_this_period !== null;
          else empty
        "
      >
        <lib-posture-line-chart
          *ngIf="!!tenant_baselines_posture_controls_in_this_period"
          [title]="'Tenant Baselines Posture Summary Chart'"
          [postureData]="tenant_baselines_posture_controls_in_this_period"
        ></lib-posture-line-chart>

        <lib-posture-line-chart
          *ngIf="!!group_baselines_posture_controls_in_this_period"
          [title]="'Group Baselines Posture Summary Chart'"
          [postureData]="group_baselines_posture_controls_in_this_period"
        ></lib-posture-line-chart>
        <p style="font-style: italic; font-size: smaller">
          <mat-icon class="grey" style="font-size: 1rem" svgIcon="info"></mat-icon>Please noted that baseline created/passing were
          not recorded before 27/09/2022.<br />
          <span style="margin-left: 1.25rem">Only Deviations after this date will be accurate.</span>
        </p>
      </div>
    </div>
  </ng-container>

  <!-- Ticket Content -->
  <ng-container *ngIf="type === 'ticket'">
    <div class="summary">
      <mat-grid-list cols="3" rowHeight="2:1">
        <mat-grid-tile colspan="1">
          <mat-card mat-elevation-z5>
            <mat-card-content>
              <h1 style="color: orange">{{ open_ticket_count }} Open</h1>
              <span>Currently</span>
            </mat-card-content>
          </mat-card>
        </mat-grid-tile>
        <mat-grid-tile colspan="1">
          <mat-card mat-elevation-z5>
            <mat-card-content>
              <h1 style="color: red">
                {{ created_ticket_count }} Created <mat-icon class="top" svgIcon="add_circle_outline"></mat-icon>
              </h1>
              <span>During this period</span>
            </mat-card-content>
          </mat-card>
        </mat-grid-tile>
        <mat-grid-tile colspan="1">
          <mat-card mat-elevation-z5>
            <mat-card-content>
              <h1 style="color: green">
                {{ resolved_ticket_count }} Resolved <mat-icon class="top" svgIcon="check_circle_outline"></mat-icon>
              </h1>
              <span>During this period</span>
            </mat-card-content>
          </mat-card>
        </mat-grid-tile>
      </mat-grid-list>
    </div>
  </ng-container>

  <ng-template #empty>
    <p class="icon">
      <mat-icon class="safe" mat-list-icon svgIcon="task_alt"></mat-icon>
      No threats were found
    </p>
  </ng-template>
</div>
